import ServiceClass from './main/ServiceClass.js';
import makePost from './main/makePost.js';
import RMCalc from './main/RMCalc.js';
import RMOrder from './main/RMOrder.js';
import './main/helpers.js';

window.rm_order_app = {
    user: null,
    // user:{login:'APITest', loginId:3228, payerId:0, contragentId:2708}, //debug ONLY
    //user:{login:'vrembo_yandex_ru', loginId:3651, payerId:0, contragentId:3450}, //debug ONLY

    params: {
        //url: 'http://api.foroom.ru/',
        url: 'https://sale.katris.ru/proxy/auth/',

        key: 'W5pRNSx8Dx3tGY65xx3BOgAAAAE',
        session: null,
        init_data: null,
        storage_name: 'rm_katris_3',
        account: null,
        container: 'RM_Order_app',
        H: null,
    },
    debug: false,
    id: Math.floor(Math.random() * (9999 - 1000)) + 1000,
    drawer: null,
    menuBlock: null,
    contentBlock: null,
    container: null,
    // templates:templates,
    discounts: null,
    discounts_pf: null,
    pastPeriodCount: 0,
    calc: null,
    basket: null,
    fabricsBlock: null,
    fabricsBlockContent: null,
    orderBlock_buttons: null,
    orderBlock_content: null,

    proccessDoneWindow: null,

    prevOrders: [],
    prevOrdersCount: 0,
    prevOrdersTypes: [],

    deliveriesList: [],
    payersList: [],
    menuItems: {},
    mid: 0,

    clearTxt: '<div style="text-align: center">ВЫБЕРИТЕ ИЗДЕЛИЕ</div>',

    selects: {
        payer: null,
        delivery: null,
        num: null,
    },

    payer: 0,
    delivery: 0,
    num: '',

    mode: 2, // 1 - под заказ, 2 - со склада
    itemsStorage: [], //что есть на складе

    isPF: false,

    noAlerts: false,

    actions: [],

    actionItems: [],

    ServiceClass: ServiceClass,
    makePost: makePost,
    click: function () {
    },
    change: function (e, o) {
        let model = o.getAttribute('model');
        if (model != null) {
            this.new_item[model] = o.value;
        }
    },
    keydown: function (e, o) {
        let model = o.getAttribute('model');
        if (model != null) {
            this.new_item[model] = o.value;
        }
    },
    keyup: function (e, o) {
        let model = o.getAttribute('model');
        if (model != null) {
            this.new_item[model] = o.value;
        }
    },
    closeDrawer: function () {
        if (this.drawer && this.container) {
            this.container.removeChild(this.drawer);
        }
    },
    closeFabricsBlock: function () {
        if (this.fabricsBlock) {
            // this.fabricsBlock.style.display='none';
        }
    },
    openFabricsBlock: function () {
        let self = this;
        if (self.fabricsBlock && self.fabricsBlockContent && self.calc) {
            self.calc.inflateFabricsBlock(self.fabricsBlockContent, self.templates.fabricsItem, function () {
                // self.fabricsBlock.style.display='block';
                // self.fabricsBlockContent.scrollTop = 0;
            });
        }
    },
    fabricItemClick: function (e, o) {
        let self = this;
        if (o.enabled) {
            let id = o.getAttribute('ihelper_commoncat-id');
            if (self.fabricsBlock && self.fabricsBlockContent && self.calc) {
                self.calc.chooseFabric(id);
            }
        } else {
            alert('Выбранной ткани временно нет в наличии!');
        }
    },
    menuItemClick: function (e, o) {
        let id = o.getAttribute('ihelper_commoncat-id');
        let disabled = o.getAttribute('disabled');
        if (disabled === 'disabled') {
            // alert('DISABLED');
        } else if (this.contentBlock) {
            id = parseInt(id);
            this.contentBlock.innerHTML = '';
            if (this.calc) delete (this.calc);
            this.calc = new RMCalc(this, id);
        }
    },
    orderItemsConfirm: function (calc) {
        if (calc && this.basket) {
            if (calc.mid < 100) {
                this.basket.store(0, calc.template);
            } else {
                this.basket.store(0, calc.template);
            }
        }
    },

    enableMenuItem: function (count) {
        for (let key in this.menuItems) {
            if (Object.prototype.hasOwnProperty.call(this.menuItems, key)) {
                if (this.mid === 0) {
                    if (this.menuItems[key].discount && count !== 0) {
                        this.menuItems[key].setAttribute('class', 'maincat disabled');
                        this.menuItems[key].setAttribute('disabled', 'disabled');
                    } else {
                        this.menuItems[key].setAttribute('class', 'maincat enabled');
                        this.menuItems[key].setAttribute('disabled', 'enabled');
                    }
                } else if (parseInt(key) === this.mid) {
                    this.menuItems[key].setAttribute('class', 'maincat enabled');
                    this.menuItems[key].setAttribute('disabled', 'enabled');
                } else {
                    this.menuItems[key].setAttribute('class', 'maincat disabled');
                    this.menuItems[key].setAttribute('disabled', 'disabled');
                }
            }
        }
    },

    orderItemAdd: function () {
        if (this.calc) {
            this.calc.store();
        }
    },

    deleteCalcItem: function (e, o) {
        let id = o.getAttribute('item-key');
        if (this.calc && this.calc.remove) {
            this.calc.remove(id);
        }
    },

    deleteOrderItem: function (e, o) {
        let id = o.getAttribute('item-key');
        let module = o.getAttribute('item-module');
        if (this[module] && this[module].remove) {
            this[module].remove(id);
            this[module].proccess();
        }
    },

    orderItemContinue: function () {
        if (this.contentBlock) {
            this.contentBlock.innerHTML = this.clearTxt;
            delete (this.calc);
        }
    },

    orderProccess: function () {
        if (this.basket) {
            if (this.calc) delete (this.calc);

            this.basket.proccess();
        }
    },

    chooseOption: function (e, o) {
        let alias = o.getAttribute('param-alias');
        let value = parseInt(o.value);
        if (alias && this.calc) {
            if (this.calc.template && this.calc.template[alias]) {
                this.calc.template[alias] = value;
            }
        }
    },

    proccessDone: function () {
        let self = this;
        let model = {
            id: self.id,
            header: 'Оформление заказа',
        };
        self.proccessDoneWindow = self.HTMLDOM(self.templates.proccessDone, model);
        self.container.appendChild(self.proccessDoneWindow);


        self.selects.payer = document.getElementById(self.id + 'proccessPayer');
        self.selects.delivery = document.getElementById(self.id + 'proccessDelivery');
        self.selects.num = document.getElementById(self.id + 'proccessNum');

        if (self.selects.payer) {
            for (let key in self.payersList) {
                if (Object.prototype.hasOwnProperty.call(self.payersList, key)) {
                    let option = document.createElement('option');
                    option.value = key;
                    option.innerHTML = self.payersList[key].showName;
                    self.selects.payer.appendChild(option);
                }
            }
        }
    },
    proccessDoneClose: function () {
        if (this.proccessDoneWindow && this.container) {
            this.container.removeChild(this.proccessDoneWindow);
        }
    },

    proccessDoneSend: function () {
        let self = this;
        let er = '';
        let order = {
            payer: self.payer,
            delivery: self.delivery,
            num: self.num,
            items: this.basket.prepareItems()
        };

        console.log(order);

        if (!order.items[0]) er += 'Добавьте товар! \n';
        if (order.payer === 0) er += 'Не выбран плательщик! \n';
        if (order.num.length <= 0) er += 'Не указан Номер Заказа! \n';
        console.log(er)
        if (er === '') {
            this.makePost('aiHelper', 'saveRMOrder_test', order, null, function (resp) {
            // this.makePost('aiHelper', 'saveRMOrder', order, null, function (resp) {
                console.log(resp)
                if (resp.data.descr) alert(resp.data.descr);
                if (resp.status === 'OK') {
                    // alert('Заказ отправлен');
                    window.location.reload();
                    // self.orderClear();
                    // console.log(resp)
                } else {
                    if (resp.errors && resp.errors[0]) {
                        alert(resp.errors[0].descr);
                    }
                }
            });
        } else {
            alert(er);
        }
    },

    number_format: window.number_format,

    orderClear: function () {
        if (this.basket) {
            this.basket.clear();
            this.clear();
        }
    },

    clear: function () {
        this.contentBlock.innerHTML = this.clearTxt;
    },

    getPrevRMOrders: function (rm_data, cb) {
        let self = this;

        self.prevOrdersCount = 0;

        if (self.isPF) {
            self.makePost('aiHelper', 'getPrevRMOrdersPF', {}, null, function (resp) {
                if (resp.status === 'OK') {
                    // console.log(resp.data)
                    for (let orders in resp.data) {
                        self.prevOrdersCount += resp.data[orders];
                    }
                }
                if (cb) cb();
            })
        }

        self.makePost('aiHelper', 'getPrevRMOrders', {}, null, function (resp) {
            if (resp.status === 'OK') {
                let prevOrders = resp.data;
                let tpl, template;
                for (let key in rm_data.items) {
                    if (Object.prototype.hasOwnProperty.call(rm_data.items, key)) {
                        tpl = rm_data.items[key];
                        template = window.clone(tpl.template);
                        if (tpl.crutch) {
                            for (let k in tpl.crutch) {
                                if (Object.prototype.hasOwnProperty.call(tpl.crutch, k)) {
                                    template[k] = tpl.crutch[k];
                                }
                            }
                        }
                    }
                    if (template && tpl) {
                        let changed_typ = template.type + '_' + template.subtype;
                        let original_typ = tpl.template.type + '_' + tpl.template.subtype;
                        if (prevOrders[changed_typ]) {
                            self.prevOrders[original_typ] = prevOrders[changed_typ];
                            self.prevOrdersCount += prevOrders[changed_typ];
                            self.prevOrdersTypes.push(original_typ);
                        } else if (prevOrders[original_typ]) {
                            self.prevOrders[original_typ] = prevOrders[original_typ];
                            self.prevOrdersCount += prevOrders[original_typ];
                            self.prevOrdersTypes.push(original_typ);
                        }
                    }
                }


            }
            if (!self.isPF) {
                if (cb) cb();
            }
        });
    },

    getInitialData: function (params = null, cb) {
        let self = this;
        if (params) {
            for (let key in params) {
                if (Object.prototype.hasOwnProperty.call(params, key)) {
                    self.params[key] = params[key];
                }
            }
        }

        if (self.params.container) {
            self.container = document.createElement('div');
            self.container.setAttribute('id', self.params.container);
            document.body.appendChild(self.container);
        }

        if (self.container) {
            self.params.H = new ServiceClass(self.params.storage_name);
            if (self.params.init_data && self.params.account) {
                //
            } else {
                this.makePost('rmOrder', 'getInitialData', {debug: this.debug}, null, function (resp) {
                    if (resp.status === 'OK') {
                        // console.log('dat', resp.data)
                        if (resp.data.rm_data) {
                            for (let mat in resp.data.rm_data.materials) {
                                resp.data.rm_data.materials[mat].notify = false;
                                resp.data.rm_data.materials[mat].notificationID = 0;
                                resp.data.rm_data.materials[mat].action = false;
                                resp.data.rm_data.materials[mat].actionSale = 0;
                                resp.data.rm_data.materials[mat].actionSales = [];
                                resp.data.rm_data.materials[mat].actionMids = [];
                                resp.data.rm_data.materials[mat].actionImage = 0;
                                resp.data.rm_data.materials[mat].storageAction = false;
                                resp.data.rm_data.materials[mat].storageActionSale = 0;
                                resp.data.rm_data.materials[mat].storageActionSales = [];
                                resp.data.rm_data.materials[mat].storageActionMids = [];
                                resp.data.rm_data.materials[mat].storageActionImage = 0;

                                //Тут подключаются акции
                                for (let action in resp.data.actions) {
                                    let matsArr = JSON.parse(resp.data.actions[action].goodsArray)
                                    for (let actionMat in matsArr) {
                                        if (mat == matsArr[actionMat]) {
                                            if (resp.data.actions[action].type == 1) {
                                                resp.data.rm_data.materials[mat].action = true;
                                                resp.data.rm_data.materials[mat].actionSale = resp.data.actions[action].sale;
                                                if (resp.data.actions[action].saleJson != '') {
                                                    resp.data.rm_data.materials[mat].actionSales = JSON.parse(resp.data.actions[action].saleJson);
                                                }
                                                if (resp.data.actions[action].systemsArray != '') {
                                                    resp.data.rm_data.materials[mat].actionMids = JSON.parse(resp.data.actions[action].systemsArray)
                                                }
                                                resp.data.rm_data.materials[mat].actionImage = resp.data.actions[action].imageLink;

                                                console.log(resp.data.rm_data.materials[mat])
                                            } else if (resp.data.actions[action].type == 2) {
                                                resp.data.rm_data.materials[mat].storageAction = true;
                                                resp.data.rm_data.materials[mat].storageActionSale = resp.data.actions[action].sale;
                                                if (resp.data.actions[action].saleJson != '') {
                                                    resp.data.rm_data.materials[mat].storageActionSales = JSON.parse(resp.data.actions[action].saleJson);
                                                }
                                                if (resp.data.actions[action].systemsArray != '') {
                                                    resp.data.rm_data.materials[mat].storageActionMids = JSON.parse(resp.data.actions[action].systemsArray)
                                                }
                                                resp.data.rm_data.materials[mat].storageActionImage = resp.data.actions[action].imageLink;
                                            }
                                        }
                                    }
                                }
                            }

                            for (let mat in resp.data.rm_data.materials_vform) {
                                resp.data.rm_data.materials_vform[mat].notify = false;
                                resp.data.rm_data.materials_vform[mat].notificationID = 0;
                                resp.data.rm_data.materials_vform[mat].action = false;
                                resp.data.rm_data.materials_vform[mat].actionSale = 0;
                                resp.data.rm_data.materials_vform[mat].actionSales = [];
                                resp.data.rm_data.materials_vform[mat].actionImage = 0;
                                resp.data.rm_data.materials_vform[mat].storageAction = false;
                                resp.data.rm_data.materials_vform[mat].storageActionSale = 0;
                                resp.data.rm_data.materials_vform[mat].storageActionSales = [];
                                resp.data.rm_data.materials_vform[mat].storageActionImage = 0;

                                //Тут подключаются акции
                                for (let action in resp.data.actions) {
                                    let matsArr = JSON.parse(resp.data.actions[action].goodsArray)
                                    for (let actionMat in matsArr) {
                                        if (mat == matsArr[actionMat]) {
                                            if (resp.data.actions[action].type == 1) {
                                                resp.data.rm_data.materials_vform[mat].action = true;
                                                resp.data.rm_data.materials_vform[mat].actionSale = resp.data.actions[action].sale;
                                                if (resp.data.actions[action].saleJson != '') {
                                                    resp.data.rm_data.materials_vform[mat].actionSales = JSON.parse(resp.data.actions[action].saleJson);
                                                }
                                                resp.data.rm_data.materials_vform[mat].actionImage = resp.data.actions[action].imageLink;
                                            } else if (resp.data.actions[action].type == 2) {
                                                resp.data.rm_data.materials_vform[mat].storageAction = true;
                                                resp.data.rm_data.materials_vform[mat].storageActionSale = resp.data.actions[action].sale;
                                                if (resp.data.actions[action].saleJson != '') {
                                                    resp.data.rm_data.materials_vform[mat].storageActionSales = JSON.parse(resp.data.actions[action].saleJson);
                                                }
                                                resp.data.rm_data.materials_vform[mat].storageActionImage = resp.data.actions[action].imageLink;
                                            }
                                        }
                                    }
                                }
                            }

                            for (let type in resp.data.rm_data.itemsCornice) {
                                for (let color in resp.data.rm_data.itemsCornice[type].multiple_prices) {
                                    resp.data.rm_data.itemsCornice[type].multiple_prices[color]['2'] = resp.data.rm_data.itemsCornice[type].multiple_prices[color]['2.0']
                                }
                            }

                            self.params.init_data = resp.data.rm_data;
                            if (resp.data.rm_data.discounts) {
                                self.discounts = resp.data.rm_data.discounts;
                            }
                            if (resp.data.rm_data.discounts_pf) {
                                self.discounts_pf = resp.data.rm_data.discounts_pf;
                            }
                            if (resp.data.pf) {
                                self.isPF = resp.data.pf;
                            }

                            if (resp.data.actions) {
                                self.actions = resp.data.actions;
                            }

                            self.itemsStorage = resp.data.rm_data.itemsStorage;

                            let compare = {
                                6: "MINI RM",
                                13: "Zebra RM",
                                14: "стандартные RM",
                                141: "картон RM"
                            }

                            //Прописываем остатки по складу
                            //MINI RM
                            for (let mat in resp.data.rm_data.items[6].multiple_prices) {
                                for (let height in resp.data.rm_data.items[6].multiple_prices[mat]) {
                                    for (let width in resp.data.rm_data.items[6].multiple_prices[mat][height]) {
                                        resp.data.rm_data.items[6].multiple_prices[mat][height][width].amount_storage_left = 0
                                        resp.data.rm_data.items[6].multiple_prices[mat][height][width].amount_storage_right = 0

                                        resp.data.rm_data.items[6].multiple_prices[mat][height][width].amount_storage_left_used = 0
                                        resp.data.rm_data.items[6].multiple_prices[mat][height][width].amount_storage_right_used = 0

                                        for (let item in self.itemsStorage) {
                                            if (self.itemsStorage[item].name == compare[6] && self.itemsStorage[item].material_id == mat && parseInt(self.itemsStorage[item].height) == (height / 10) && parseInt(self.itemsStorage[item].width) == (width / 10)) {
                                                resp.data.rm_data.items[6].multiple_prices[mat][height][width].amount_storage_right = self.itemsStorage[item].count
                                            }
                                        }

                                    }
                                }
                            }

                            //ZEBRA
                            for (let mat in resp.data.rm_data.items[13].multiple_prices) {
                                for (let height in resp.data.rm_data.items[13].multiple_prices[mat]) {
                                    for (let width in resp.data.rm_data.items[13].multiple_prices[mat][height]) {
                                        resp.data.rm_data.items[13].multiple_prices[mat][height][width].amount_storage_left = 0
                                        resp.data.rm_data.items[13].multiple_prices[mat][height][width].amount_storage_right = 0

                                        resp.data.rm_data.items[13].multiple_prices[mat][height][width].amount_storage_left_used = 0
                                        resp.data.rm_data.items[13].multiple_prices[mat][height][width].amount_storage_right_used = 0

                                        for (let item in self.itemsStorage) {
                                            if (self.itemsStorage[item].name == compare[13] && self.itemsStorage[item].material_id == mat && parseInt(self.itemsStorage[item].height) == (height / 10) && parseInt(self.itemsStorage[item].width) == (width / 10)) {
                                                resp.data.rm_data.items[13].multiple_prices[mat][height][width].amount_storage_right = self.itemsStorage[item].count
                                            }
                                        }

                                    }
                                }
                            }

                            //ГЖ Картон
                            for (let mat in resp.data.rm_data.items[141].multiple_prices) {
                                for (let height in resp.data.rm_data.items[141].multiple_prices[mat]) {
                                    for (let width in resp.data.rm_data.items[141].multiple_prices[mat][height]) {
                                        resp.data.rm_data.items[141].multiple_prices[mat][height][width].amount_storage_left = 0
                                        resp.data.rm_data.items[141].multiple_prices[mat][height][width].amount_storage_right = 0

                                        resp.data.rm_data.items[141].multiple_prices[mat][height][width].amount_storage_left_used = 0
                                        resp.data.rm_data.items[141].multiple_prices[mat][height][width].amount_storage_right_used = 0

                                        for (let item in self.itemsStorage) {
                                            if (self.itemsStorage[item].name == compare[141] && self.itemsStorage[item].material_id == mat && parseInt(self.itemsStorage[item].height) == (height / 10) && parseInt(self.itemsStorage[item].width) == (width / 10)) {
                                                if (self.itemsStorage[item].controlSide == 1) {
                                                    resp.data.rm_data.items[141].multiple_prices[mat][height][width].amount_storage_left = self.itemsStorage[item].count
                                                } else if (self.itemsStorage[item].controlSide == 2) {
                                                    resp.data.rm_data.items[141].multiple_prices[mat][height][width].amount_storage_right = self.itemsStorage[item].count
                                                }
                                            }
                                        }

                                    }
                                }
                            }

                        }
                        self.getPrevRMOrders(self.params.init_data, cb);
                    }
                });
            }
        }
    },

    init: function (cb) {
        let self = this;
        self.getInitialData(null, function () {
            self.makePost('aiHelper', 'payersList', {}, null, function (resp) {
                if (resp.status === 'OK') {
                    if (resp.data && resp.data.payers) {
                        if (resp.data.payers) self.payersList = resp.data.payers;
                        if (resp.data.deliveries) self.deliveriesList = resp.data.deliveries;

                        if (cb) cb();
                    }
                } else {
                    // console.log(resp)
                }
            });

            self.basket = new RMOrder(self);
        });
    },
};

export default window.rm_order_app;
